import { render, staticRenderFns } from "./FavoritesPage.vue?vue&type=template&id=49c5017e"
import script from "./FavoritesPage.vue?vue&type=script&lang=js"
export * from "./FavoritesPage.vue?vue&type=script&lang=js"
import style0 from "./FavoritesPage.vue?vue&type=style&index=0&id=49c5017e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports